<template>
  <!-- 登录-->
  <div class="login">
    <ul class="head">
      <li class="head-left">
        <img src="../../assets/images/web/logo.svg" alt="">
        <a-divider type="vertical" />
        <span class="text" @click="debugBtn++">浩邈账号中心</span>
      </li>
      <li class="head-right">
        <span class="text">帮助中心</span>
        <a-divider type="vertical" />
        <span class="text" @click="showPrivacy">隐私政策</span>
        <a-divider type="vertical" />
        <span class="text" @click="showRegister">用户协议</span>
      </li>
    </ul>

    <div class="form-box">

      <!-- 引导语标题-->
      <h1 class="title" :class="{'guide-title': relationAccount}" v-if="operateType === 'phoneLogin' || operateType === 'pwdLogin'">登录</h1>
      <h1 class="title" :class="{'guide-title': relationAccount}" v-else-if="operateType === 'isRegister' && registerStep !== 3">注册</h1>
      <h1 class="title" :class="{'guide-title': relationAccount}" v-else-if="operateType === 'forgetPwd'">找回密码</h1>

      <!-- 引导语-->
      <p v-if="!relationAccount" class="to-register">
        <template v-if="operateType === 'pwdLogin' || operateType === 'phoneLogin'">
          <span class="text-1">没有账号？</span>
          <span @click="toRegister" class="text-2">立即注册</span>
        </template>

        <template v-if="operateType === 'isRegister' && registerStep !== 3">
          <span class="text-1">已有账号，</span>
          <span @click="backLogin" class="text-2">返回登录</span>
        </template>

        <template v-if="operateType === 'forgetPwd'">
          <span @click="backLogin" class="text-2">返回登录</span>
        </template>
      </p>

      <!-- 密码登录-->
      <div v-if="operateType === 'pwdLogin'">
        <a-form
          ref="pwdLogin"
          class="login-form"
          :model="formState"
          :rules="rules"
        >
          <a-form-item name="username">
            <a-input v-model:value="formState.username" placeholder="账号">
              <template #prefix>
                <img src="../../assets/images/web/user.svg" alt="">
              </template>
            </a-input>
          </a-form-item>

          <a-form-item name="password">
            <a-input-password v-model:value="formState.password" type="password" autocomplete placeholder="密码">
              <template #prefix>
                <img src="../../assets/images/password.svg" alt="">
              </template>
            </a-input-password>
          </a-form-item>

          <a-form-item class="remember" name="remember">
            <a-checkbox class="remember-pwd" v-model:checked="formState.remember">自动登录</a-checkbox>
          </a-form-item>

          <a-button
            @click="showVerify"
            block
            type="primary"
            html-type="submit"
            :disabled="formState.username === ''||formState.password === ''"
            :loading="btnLoading.loading"
            style="height:50px"
          >登录</a-button>
        </a-form>

        <ul class="other">
          <li class="text" @click="this.operateType = 'phoneLogin'">手机号登录</li>
          <li class="text" @click="this.operateType = 'forgetPwd'">忘记密码</li>
        </ul>
      </div>

      <!-- 注册-->
      <template v-if="operateType === 'isRegister'">
        <a-form
          class="login-form"
          ref="registerForm"
          :model="registerState"
          :rules="registerRules"
          @finish="setPassword"
        >
          <div v-show="registerStep === 1">
            <a-form-item name="phone">
              <a-input v-model:value="registerState.phone" placeholder="请输入手机号">
                <template #prefix>
                  <img src="../../assets/images/Phone.svg" alt="">
                </template>
              </a-input>
            </a-form-item>

            <a-form-item name="smscode">
              <a-input v-model:value="registerState.smscode" placeholder="短信验证码">
                <template #prefix>
                  <img src="../../assets/images/verify.svg" alt="">
                </template>

                <template #suffix>
                  <span v-if=second.value class="sms-code">{{second.value + 'S'}}</span>
                  <span v-else @click="showNewVerify" class="fetch-code">发送验证码</span>
                </template>
              </a-input>
            </a-form-item>

            <a-form-item name="agreement">
              <a-checkbox class="remember-pwd" v-model:checked="registerState.agreement">
                <span class="agree">已阅读并同意浩邈账号<span class="user-agree" @click.self="showRegister">《用户协议》</span><span class="agree">和</span><span class="user-agree" @click.self="showPrivacy">《隐私政策》</span></span>
              </a-checkbox>
            </a-form-item>

            <a-button
              @click="register"
              block
              type="primary"
              :disabled="registerState.phone === ''||
                registerState.smscode === ''||
                registerState.agreement === false"
              :loading="btnLoading.loading"
               style="height:50px"
            >注册</a-button>
          </div>

          <div v-show="registerStep === 2">
            <p style="color:#8F9099">您注册的手机号为：{{formatephone(registerState.phone)}}</p>
            <p style="margin-bottom:30px;color:#8F9099">请设置登录密码，密码长度6~32数字或字母组合，区分大小写</p>
            <a-form-item name="newPassword">
              <a-input-password v-model:value="registerState.newPassword" type="password" autocomplete placeholder="设置密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>
            <a-form-item name="confirmPassword">
              <a-input-password v-model:value="registerState.confirmPassword" type="password" autocomplete placeholder="确认密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>

            <a-button
              block
              html-type="submit"
              type="primary"
              :disabled="registerState.newPassword === ''||
              registerState.confirmPassword === ''"
              :loading="btnLoading.loading"
               style="height:50px"
            >提交</a-button>
          </div>

          <div v-show="registerStep === 3" class="reg-finish">
            <div class="icon-box">
              <img class="icon" src="../../assets/images/mobile/smile.svg" alt="">
            </div>
            <p class="reg-finish-tip">您的账号：{{registerState.phone}} 已成功注册！</p>
            <button @click="backLogin" class="button">立即登录</button>
            <button @click="backLogin" class="button button-plain" style="margin-top: 16px">返回首页</button>
          </div>
        </a-form>
      </template>

      <!-- 忘记密码-->
      <template v-if="operateType === 'forgetPwd'">
        <a-form
          ref="forgetForm"
          class="login-form"
          :model="forgetState"
          :rules="forgetRules"
        >
          <div v-show="forgetStep === 1">
          <a-form-item name="phone">
            <a-input v-model:value="forgetState.phone" placeholder="请输入手机号">
              <template #prefix>
                <img src="../../assets/images/Phone.svg" alt="">
              </template>
            </a-input>
          </a-form-item>

          <a-form-item name="smscode">
            <a-input v-model:value="forgetState.smscode" placeholder="短信验证码">
              <template #prefix>
                <img src="../../assets/images/verify.svg" alt="">
              </template>

              <template #suffix>
                <span v-if=second.value class="sms-code">{{second.value + 'S'}}</span>
                <span v-else @click="showNewFPVerify" class="fetch-code">发送验证码</span>
              </template>
            </a-input>
          </a-form-item>
          </div>

          <div v-if="forgetStep === 2">
            <a-form-item name="newPassword">
              <a-input-password v-model:value="forgetState.newPassword" type="password" autocomplete placeholder="设置密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>
            <a-form-item name="confirmPassword">
              <a-input-password v-model:value="forgetState.confirmPassword" type="password" autocomplete placeholder="确认密码">
                <template #prefix>
                  <img src="../../assets/images/password.svg" alt="">
                </template>
              </a-input-password>
            </a-form-item>
          </div>

          <a-button
            v-show="forgetStep === 1"
            @click="forgetPwdNext"
            block
            type="primary"
            :disabled="forgetState.phone === ''||
              forgetState.smscode === ''"
            :loading="btnLoading.loading"
             style="height:50px"
          >下一步</a-button>

          <a-button
            @click="submitForgetPwd"
            v-show="forgetStep === 2"
            block
            html-type="submit"
            type="primary"
            :disabled="forgetState.newPassword === ''||
              forgetState.confirmPassword === ''"
            :loading="btnLoading.loading"
             style="height:50px"
          >提交</a-button>
        </a-form>
      </template>

      <!-- 手机号登录-->
      <template v-if="operateType === 'phoneLogin'">
        <a-form
          ref="phoneLogin"
          class="login-form"
          :model="phoneState"
          :rules="phoneLoginRules"
          @finish="submitPhoneLogin"
        >
          <a-form-item name="phone">
            <a-input v-model:value="phoneState.phone" placeholder="请输入手机号">
              <template #prefix>
                <img src="../../assets/images/Phone.svg" alt="">
              </template>
            </a-input>
          </a-form-item>

          <a-form-item name="smscode">
            <a-input v-model:value="phoneState.smscode" placeholder="短信验证码">
              <template #prefix>
                <img src="../../assets/images/verify.svg" alt="">
              </template>

              <template #suffix>
                <span v-if=second.value class="sms-code">{{second.value + 'S'}}</span>
                <span v-else @click="showNewPLVerify" class="fetch-code">发送验证码</span>
              </template>
            </a-input>
          </a-form-item>

          <a-button
            block
            type="primary"
            html-type="submit"
            :disabled="phoneState.phone === '' || phoneState.smscode === ''"
            :loading="btnLoading.loading"
            style="height:50px"
          >登录</a-button>
        </a-form>

        <ul class="other">
          <li class="text" @click="backLogin">密码登录</li>
          <li class="text" @click="() => {this.operateType = 'forgetPwd';}">忘记密码</li>
        </ul>
      </template>

      <!-- 微信登录-->
      <ul v-if="!relationAccount && (operateType==='pwdLogin')" class="other-login">
        <li @click="getWXQR">
          <img class="icon-wechat" src="../../assets/images/web/icon_wechat.svg" alt="">
          <p class="text">微信登录</p>
        </li>
      </ul>
    </div>

    <footer>
      <span class="text">厦门浩邈科技有限公司 版权所有 © 2016-{{ currentYear }}</span>
    </footer>

    <!--微信登录的弹窗-->
    <a-modal
      class="bind-wechat-modal"
      :visible="visible"
      @cancel="visible=false"
      @ok="visible = false"
      :maskClosable="false"
      :keyboard="false"
      :destroyOnClose="true"
      :centered="true"
      :closable="true"
      :footer="null"
    >
      <div id="login_container"></div>
    </a-modal>

    <!--账号未关联 或 确认关联的弹窗-->
    <a-modal
      class="relation-account-modal"
      :visible="relationVisible"
      @cancel="relationVisible=false"
      :mask="false"
      :maskClosable="false"
      :keyboard="false"
      :destroyOnClose="true"
      :centered="true"
      :closable="false"
      :footer="null"
    >
      <!--  微信未关联过-->
      <template v-if="!allocated">
        <p class="title">确认关联账号</p>
        <div class="avatar">
          <div class="pic-box">
            <img class="pic" :src="wxUserInfo.headimgurl" alt="">
          </div>
          <p class="name">{{wxUserInfo.nickname}}</p>
          <p class="text">您的微信尚未关联浩邈账号</p>
        </div>
        <div class="btn-box">
        <a-button @click="loginByAccount" block type="primary">登录已有账号</a-button>
        <a-button @click="createAccount" block>创建新账号</a-button>
        </div>
      </template>

      <!--  微信已关联过-->
      <template v-if="allocated">
        <p class="title">确认关联账号</p>
        <div class="avatar">
          <div class="pic-box">
            <img class="pic" :src="wxUserInfo.headimgurl" alt="">
          </div>
          <p class="name">{{wxUserInfo.nickname}}</p>
          <p class="text">关联后您可以用微信快捷登录</p>
        </div>
        <div class="btn-box">
        <a-button block type="primary" @click="handleRelate">确认关联</a-button>
        <a-button block @click="cancelRelate">取消</a-button>
        </div>
      </template>
    </a-modal>

    <!-- 验证码弹窗-->

    <!--newBlockPuzzle blockPuzzle clickWord -->
    <Verify
      @success="success"
      mode="pop"
      captchaType="clickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="verify"
    />
    <!-- 注册 -->
    <Verify
      v-if="showVerity"
      @success="reqSmsCode"
      mode="pop"
      captchaType="newClickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newVerify"
      :phone = "registerState.phone"
    />

    <!-- 手机登录 phoneLogin -->
    <Verify
      v-if="showPLVerity"
      @success="phoneLoginGetCode"
      mode="pop"
      captchaType="newClickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newPLVerify"
      :phone = "phoneState.phone"
    />

    <!-- 忘记密码 forgotPassword -->
    <Verify
      v-if="showFPVerity"
      @success="forgetGetCode"
      mode="pop"
      captchaType="newClickWord"
      :imgSize="{ width: '330px', height: '155px' }"
      ref="newFPVerify"
      :phone = "forgetState.phone"
    />
  </div>
</template>

<script>
import { defineComponent, reactive, ref, computed, onBeforeMount, toRaw } from 'vue';
import Common, { CookieApi } from '@/utils/common';
import { login } from '@/utils/api';
import { loginModule } from '@/utils/mixin';
import { APP_ID, APP_SECRET, PLAT_TYPE, FROM_OS, redirectUrl } from '@/utils/constant';
import { getAgreement, showPrivacy, showRegister } from '@/utils/setup/agreement';
import Verify from '@/components/verifition/Verify';
import moment from 'moment';
import store from '@/store';
import { MD5 } from 'crypto-js';
import { pwdValidate } from '@/utils/setup/pwdValidate';

export default {
  name: 'login',
  mixins: [loginModule],
  components: { Verify },
  setup () {
    onBeforeMount(() => {
      getAgreement();
    });
    // 密码登录、注册、手机号登录
    return { showPrivacy, showRegister };
  },
  data () {
    const phone = [
      { required: true, message: '请输入手机号' },
      { pattern: /^1\d{10}$/, message: '手机号为11位有效数字' }
    ];
    const newPassword = [
      { validator: pwdValidate }
    ];
    const smscode = [{ required: true, message: '请输入验证码' }];
    const agreement = [{ required: true, message: '请勾选用户协议和隐私政策' }];

    return {
      showVerity: false,
      showPLVerity: false,
      showFPVerity: false,
      formState: { username: '', password: '', code: '', remember: false },
      registerState: { phone: '', smscode: '', agreement: false, newPassword: '', confirmPassword: '' },
      debugBtn: 0,
      wxUserInfo: {},
      isRegisterBindWx: 0,
      allocated: false,
      relationAccount: false,
      operateType: 'pwdLogin',
      wxCode: '',
      btnLoading: { loading: false },
      forgetStep: 1,
      registerStep: 1,
      visible: false,
      relationVisible: false,
      forgetState: { phone: '', smscode: '', newPassword: '', confirmPassword: '' },
      rules: {
        username: [
          { required: true, message: '请输入账号' },
          { min: 1, max: 20, message: '账号为1-20位' }
        ],
        password: [{ required: true, message: '请输入密码' }]
      },
      registerRules: {
        phone,
        smscode,
        agreement,
        newPassword,
        confirmPassword: [
          { validator: pwdValidate },
          { validator: (rule, value, callback) => this.samePassword(rule, value, callback, 'registerState') }
        ]
      },
      forgetRules: {
        phone,
        smscode,
        newPassword,
        confirmPassword: [
          { validator: pwdValidate },
          { validator: (rule, value, callback) => this.samePassword(rule, value, callback, 'forgetState') }
        ]
      },
      phoneState: { phone: '', smscode: '', appId: '', appSecret: '', fromOs: '' },
      phoneLoginRules: { phone, smscode }
    };
  },
  computed: {
    currentYear () {
      return moment().format('YYYY');
    }
  },
  created () {
    const wxCode = this.$route.query.code;
    if (wxCode) { // 微信网站授权的code
      this.wechatLogin(wxCode);
    }
    this.setUserData();
  },
  methods: {
    formatephone (val) {
      let mobile = val.replace(/^(.{3})(.*)(.{4})/, '$1 $2 $3');
      return mobile;
    },
    resetOptionsData () {
      Object.assign(this.$data, this.$options.data(this));
    },
    setUserData () {
      const userData = CookieApi.get('userData');
      const data = userData ? JSON.parse(userData) : {};
      if (data.password) {
        data.remember = data.remember === 1;
        Object.assign(this.formState, data);
      }
    },
    samePassword (rule, value, callback, state) {
      let pwdVal = this[state].newPassword;
      if (value !== pwdVal) {
        callback(new Error('两次密码不一致'));
      } else {
        callback();
      }
    },
    /** 展示验证码弹窗 */
    showVerify () {
      this.$refs.pwdLogin.validate().then((res) => {
        this.$refs.verify.show();
      });
    },
    /** 验证码 验证成功 */
    success (verification) {
      const { captchaVerification } = verification;
      this.submitLogin(captchaVerification);
    },
    /** 提交(密码登录) */
    submitLogin (verification) {
      let formValue = {...this.formState }; // 这段代码可以不写
      formValue.password = MD5(formValue.password).toString();
      formValue.appId = APP_ID;
      formValue.appSecret = APP_SECRET;

      this._post({
        url: login.loginByPwd,
        query: {
          // code: formValue.code,
          // uuid: this.imageCodeData.uuid,
          captchaVerification: verification,
          grantType: 'password'
        },
        params: formValue,
        btnLoading: this.btnLoading
      }).then(({ data }) => {
        this.rememberPwd(this.formState);
        this.loginSuccessHandle(data);
      });
    },
    /** 记住密码 */
    rememberPwd (formValue) {
      if (formValue.remember === true) {
        let { username, password, remember } = formValue;
        remember = remember === true ? 1 : 0;
        CookieApi.set('userData', JSON.stringify({ username, password, remember }));
      } else {
        CookieApi.remove('userData');
      }
    },
    /** 登录成功后的处理 */
    loginSuccessHandle (data) {
      CookieApi.set('refreshToken', data.refreshToken);
      this.setToken(data.accessToken);

      store.commit('setUserInfo', { uid: data.userId });

      if (!this.relationAccount) {
        PLAT_TYPE === 'acsecurity' && this.$message.success('登录成功');
        this.handleRouter();
      } else {
        this.allocated = true;
        this.relationVisible = true;
      }
    },
    /** 微信获取验证码 */
    getWXQR () {
      this.visible = true;
      this.$nextTick(() => {
        Common.WXLogin();
      });
    },
    /** 微信扫码登录 */
    wechatLogin (code) {
      this._post({
        url: '/userLogin/wxCallback',
        query: {
          code: code,
          state: `${APP_ID}-${APP_SECRET}`
        }
      }).then(({ data }) => {
        if (data.accessToken) { // 微信用户已关联系统账号
          this.loginSuccessHandle(data);
        } else { // 未关联系
          this.wxUserInfo = data;
          this.relationVisible = true;
        }
      });
    },
    /** 登录已有账号 */
    loginByAccount () {
      this.relationVisible = false;
      this.relationAccount = true;
      this.operateType = 'pwdLogin';
    },
    /** 创建新账号 */
    createAccount () {
      this.relationVisible = false;
      this.relationAccount = true;
      this.operateType = 'isRegister';
    },
    /**
     * 取消关联
     * 直接进入应用（其实已注册或注册成功）
     * */
    cancelRelate () {
      this.$message.success('登录成功');
      this.handleRouter();
    },
    /** 确认关联 */
    handleRelate () {
      const userId = computed(() => store.state.userInfo.uid);
      this._post({
        url: '/user/wxBindUser',
        params: {
          userId: userId.value,
          ...this.wxUserInfo, // 微信用户信息
          ssoType: 'weixin_app',
          isRegisterBindWx: this.isRegisterBindWx
        }
      }).then(({ data }) => {
        this.$message.success('关联成功');
        this.isRegisterBindWx = 0;
        this.handleRouter();
      });
    },
    handleRouter () {
      console.log('PLAT_TYPE: ', PLAT_TYPE);
      if (PLAT_TYPE === 'acsecurity') {
        this.$router.push({ name: 'security' });
      } else {
        location.href = redirectUrl;
      }
    },
    /** 获取手机验证码(图形验证) */
    showNewPLVerify () {
      this.$refs.phoneLogin.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showPLVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newPLVerify.show();
        }, 100);
      });
    },
    /** 获取手机验证码(手机号登录) */
    phoneLoginGetCode (verification) {
      this.showPLVerity = false;
      const { captchaVerification } = verification;
      this.$refs.phoneLogin.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 3, captchaVerification);
      });
    },
    /** 提交登录（手机号登录） */
    submitPhoneLogin () {
      this._post({
        url: '/userLogin/smsLogin',
        params: {
          ...this.phoneState,
          appId: APP_ID,
          appSecret: APP_SECRET,
          fromOs: FROM_OS
        }
      }).then(({ data }) => {
        this.loginSuccessHandle(data);
      });
    },
    /** 进入注册 */
    toRegister () {
      this.operateType = 'isRegister';
    },

    /** 获取验证码（注册） */
    showNewVerify () {
      this.$refs.registerForm.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newVerify.show();
        }, 100);
      });
    },

    reqSmsCode (verification) {
      this.showVerity = false;
      const { captchaVerification } = verification;
      this.$refs.registerForm.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 4, captchaVerification).then((res) => {
          if (res === 30011) {
            this.registerState.phone = '';
            this.operateType = 'pwdLogin';
          }
        });
      });
    },
    /** 提交注册 */
    register () {
      this.$refs.registerForm.validate(['phone', 'smscode', 'agreement']).then((res) => {
        this._post({
          url: '/user/registerByPhone',
          params: {
            ...res,
            platType: PLAT_TYPE,
            fromOs: FROM_OS // 注册平台 1:IOS 2:Android 3:web
          }
        }).then(({ data }) => {
          this.registerStep = 2;
        });
      });
    },
    /** 设置密码（注册后操作） */
    setPassword () {
      this.$refs.registerForm.validate().then((res) => {
        let { phone, newPassword, confirmPassword } = { ...res };
        newPassword = MD5(newPassword).toString();
        confirmPassword = MD5(confirmPassword).toString();
        if (this.relationAccount === true) { // 微信扫码后注册并设置密码
          this._post({
            url: '/user/updatePwdByPhone/login',
            params: {
              phone,
              newPassword,
              confirmPassword,
              appId: APP_ID,
              appSecret: APP_SECRET
            }
          }).then(({ data }) => {
            this.isRegisterBindWx = 1;
            this.loginSuccessHandle(data);
          });
        } else { // 一般注册
          this._post({
            url: '/user/updatePwdByPhone',
            params: { phone, newPassword, confirmPassword }
          }).then(({ data }) => {
            this.$message.success('注册成功');
            this.registerStep = 3;
          });
        }
      });
    },
    /** 获取验证码（图形验证） */
    showNewFPVerify () {
      this.$refs.forgetForm.validate(['phone']).then((res) => {
        setTimeout(() => {
          this.showFPVerity = true;
        }, 0);

        setTimeout(() => {
          this.$refs.newFPVerify.show();
        }, 100);
      });
    },
    /** 获取验证码（忘记密码） */
    forgetGetCode (verification) {
      this.showFPVerity = false;
      const { captchaVerification } = verification;
      this.$refs.forgetForm.validate(['phone']).then((res) => {
        this.getCaptcha(res.phone, 0, captchaVerification);
      });
    },
    /** 验证验证码(忘记密码) */
    forgetPwdNext () {
      this._post({
        url: '/userLogin/checkCode',
        params: {
          ...this.forgetState,
          type: 0, // 0：忘记密码
          platType: PLAT_TYPE
        }
      }).then(({ data }) => {
        this.forgetStep = 2;
      });
    },
    /** 提交（忘记密码） */
    submitForgetPwd () {
      this.$refs.forgetForm.validate(['newPassword', 'confirmPassword']).then((res) => {
        let data = {...this.forgetState };
        data.newPassword = MD5(data.newPassword).toString();
        data.confirmPassword = MD5(data.confirmPassword).toString();
        this._post({
          url: '/user/forgetPassword',
          params: data
        }).then(({ data }) => {
          this.$message.success('修改成功');
          this.forgetStep = 1;
          this.backLogin();
        });
      });
    },
    /** 返回登录 */
    backLogin () {
      this.resetOptionsData();
    }
  }
};
</script>

<style lang="scss" scoped>
.login {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 100vh;
  background-image: url('../../assets/images/web/bg_login_web.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  border: 1px solid #e9edf3;
  .head {
    position: absolute;
    top: 0px;
    left: 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 32px;
    width: 100%;
    height: 72px;
    .head-left {
      .ant-divider {
        height: 16px;
      }
      .text {
        color: #00132e;
        font-weight: 600;
        font-size: 16px;
      }
    }
    .head-right {
      .ant-divider {
        height: 10px;
      }
      .text {
        padding: 0 24px;
        color: #868f9c;
        font-size: 14px;
        cursor: pointer;
      }
    }
  }

  .title {
    color: #00132e;
    font-weight: 600;
    font-size: 24px;
    line-height: 24px;
  }
  .guide-title {
    margin-bottom: 32px;
  }
  .form-box {
    padding: 32px;
    width: 480px;
    border: 1px solid #e9edf3;
    box-sizing: border-box;
    background: #ffffff;
    .remember {
      height: auto;
      padding-bottom: 16px;
    }
    .remember-pwd {
      color: #abb2bd;
      font-size: 14px;
      line-height: 14px;
      .agree {
        color: rgba(43, 54, 74, 1);
        font-size: 14px;
      }
      .user-agree {
        color: rgba(68, 129, 235, 1);
        font-size: 14px;
      }
    }
    .other {
      padding: 0 16px;
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .text {
        color: #abb2bd;
        font-size: 14px;
        line-height: 14px;
        cursor: pointer;
      }
    }
    .other-login {
      margin-top: 64px;
      display: flex;
      justify-content: center;
      .icon-wechat {
        cursor: pointer;
      }
      .text {
        margin-top: 8px;
        color: #abb2bd;
        font-size: 12px;
        line-height: 12px;
      }
    }
  }
  footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 56px;
    padding-left: 32px;
    display: flex;
    align-items: center;
    .text {
      color: #abb2bd;
      font-size: 14px;
    }
  }
}
</style>

<style lang="scss">
.login-form {
  transition: all 0.5s;
  .form-item-agreement {
    height: 48px;
  }
  .ant-form-item-explain {
    font-size: 12px;
  }
  .ant-input {
    height: 38px;
  }
  .sms-code {
    color: rgba(171, 178, 189, 1);
    font-size: 14px;
  }
  .fetch-code {
    color: rgba(68, 129, 235, 1);
    font-size: 14px;
    cursor: pointer;
  }
  .image-code {
    width: 110px;
    height: 36px;
    cursor: pointer;
  }
}

.relation-account-modal {
  .title {
    color: rgba(0, 19, 46, 1);
    font-size: 16px;
  }
  .avatar {
    margin-top: 64px;
    text-align: center;
    .pic-box {
      margin: 0 auto;
      height: 96px;
      width: 96px;
      border-radius: 50%;
      overflow: hidden;
      .pic {
        width: 100%;
      }
    }
    .name {
      margin-top: 12px;
      color: rgba(0, 19, 46, 1);
      font-family: PingFang SC;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
    }
    .text {
      margin-top: 12px;
      color: rgba(134, 143, 156, 1);
      font-family: PingFang SC;
      font-size: 14px;
      line-height: 18px;
    }
  }
  .btn-box {
    margin-top: 32px;
    .ant-btn {
      height: 56px;
    }
    .ant-btn+.ant-btn {
      margin-top: 16px;
    }
  }
}
</style>
